export const initialPurchasePlanForm: App.IPurchasePlanForm = {
  isEnterprise: false,
  planKey: "",
  name: "",
  product: "",
  description: ""
}

export const initialPricingVariablesItem: App.ISimplePricingVariable = {
  eventType: "",
  usageLimit: "",
  label: "",
  price: "",
  isQuota: false,
  isUpdatable: true
}

export const initialPurchasePlanPricing: App.IPurchasePlanPricing = {
  fromPriceUnit: "",
  isSimplifiedPricing: true
}
